import React from 'react';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="section-container" data-id="element-148">
      <div className="text-container" data-id="element-149">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft border border-gold/20 relative overflow-hidden" data-id="element-150">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full -z-0" data-id="element-151"></div>

          <div className="relative z-10" data-id="element-152">
            <div className="flex gap-1 text-gold mb-6" data-id="element-153">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-154" />)}
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-charcoal-dark mb-6" data-id="element-155">
              Lo que cambia en 7 días:
            </h2>

            <p className="text-lg md:text-xl leading-relaxed text-charcoal-light mb-8 font-medium italic" data-id="element-156">
              "No solo verás tu abdomen más plano en el espejo; empezarás a
              notar que tu energía regresa, duermes mejor y esa sensación de
              pesadez después de comer desaparece por completo."
            </p>

            <div className="inline-block bg-sage-light/30 px-6 py-3 rounded-xl border border-sage-dark/20" data-id="element-157">
              <p className="text-charcoal-dark font-bold" data-id="element-158">
                Es el <span className="text-sage-dark" data-id="element-159">"efecto ligereza"</span>{' '}
                que solo ocurre cuando dejas de pelear con tus hormonas y
                empiezas a trabajar con ellas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}